import state from '@/stores/accounts/state.js'
import mutations from '@/stores/accounts/mutations.js'
import actions from '@/stores/accounts/actions.js'

export default {
  state,
  mutations,
  actions
}
